import Helpers from '../../common/helpers/Helpers';
import Constants from '../../common/constants/Constants';

export const getRegion = regionId => {
  return Helpers.get(`${Constants.REGIONS_URL}/${regionId}`);
};

export const updateRegion = region => {
  return Helpers.put(Constants.REGIONS_URL, {}, region);
};

export const getUsersOfRegion = regionId => {
  return Helpers.get(`${Constants.REGIONS_URL}/${regionId}/users`);
};

export const addUserToRegion = (regionId, userId) => {
  return Helpers.post(`${Constants.REGIONS_URL}/${regionId}/users/${userId}`);
};

export const removeUserFromRegion = (regionId, userId) => {
  return Helpers.delete(`${Constants.REGIONS_URL}/${regionId}/users/${userId}`);
};

export const getInstrumentsOfRegion = regionId => {
  return Helpers.get(`${Constants.REGIONS_URL}/${regionId}/instruments`);
};

export const getAssignableUsersToRegion = regionId => {
  return Helpers.get(`${Constants.REGIONS_URL}/${regionId}/unassignedusers`);
};
